import { MessageCircle } from "lucide-react";
import { useT } from "../../i18n/i18nContext";

const SUIKAMON_X_ACCOUNT_URL = "https://x.com/suikamongame";

interface FeedbackButtonProps {
  /**
   * Lift the pill above the sticky "play your first Suikamon" banner, which spans the full
   * width of the viewport bottom and would otherwise sit under this button's corner.
   */
  raised?: boolean;
}

export function FeedbackButton({ raised = false }: FeedbackButtonProps) {
  const t = useT();
  return (
    <div
      className={`suikamon-feedback-button${raised ? " suikamon-feedback-button--raised" : ""}`}
    >
      <a
        href={SUIKAMON_X_ACCOUNT_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t("navigation.app.feedbackAria")}
      >
        <MessageCircle size={18} />
        <span>{t("navigation.app.feedback")}</span>
      </a>
    </div>
  );
}
